function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  stroke: "#F64B39",
  strokeWidth: 7,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M43 57L50 35C52 29 57 26 63 26H97C103 26 108 29 110 35L117 57"
}), /*#__PURE__*/React.createElement("path", {
  d: "M35 57H125C131 57 135 62 135 68V94C135 103 128 110 119 110H41C32 110 25 103 25 94V68C25 62 29 57 35 57Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25 64H19"
}), /*#__PURE__*/React.createElement("path", {
  d: "M135 64H141"
}), /*#__PURE__*/React.createElement("path", {
  d: "M41 110V116C41 122 45 126 51 126C57 126 61 122 61 116V110"
}), /*#__PURE__*/React.createElement("path", {
  d: "M99 110V116C99 122 103 126 109 126C115 126 119 122 119 116V110"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 47,
  cy: 82,
  r: 6,
  fill: "#F64B39",
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 113,
  cy: 82,
  r: 6,
  fill: "#F64B39",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M63 102H97"
}));

function SvgCar(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u0410\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u044C") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.525d2de0f2f1576603139578ef9f4ecb.svg";
export { ForwardRef as ReactComponent };